import { useState, useRef, useEffect } from 'react';
import './PhoneInput.css';

const COUNTRIES = [
  { code: '+49', country: 'DE', flag: '🇩🇪', label: 'Germany' },
  { code: '+216', country: 'TN', flag: '🇹🇳', label: 'Tunisia' },
];

export default function PhoneInput({ value, onChange, required = false }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const detected = COUNTRIES.find(c => value?.startsWith(c.code)) || COUNTRIES[0];
  const [selected, setSelected] = useState(detected);
  const [number, setNumber] = useState(
    value ? value.replace(detected.code, '').trim() : ''
  );

  // Validation
  const digits = number.replace(/[\s\-]/g, '');
  const isValid = digits.length >= 7 && digits.length <= 12;
  const showFeedback = number.length > 0;

  useEffect(() => {
    function handleClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  function handleCountrySelect(country) {
    setSelected(country);
    setOpen(false);
    onChange(`${country.code} ${number}`.trim());
  }

  function handleNumberChange(e) {
    const val = e.target.value.replace(/[^\d\s\-]/g, '');
    setNumber(val);
    onChange(`${selected.code} ${val}`.trim());
  }

  return (
    <div className="pi-wrapper" ref={wrapperRef}>
      <div
        className="pi-input"
        style={{
          borderColor: showFeedback
            ? isValid ? 'rgba(76,175,125,0.6)' : 'rgba(232,52,26,0.6)'
            : ''
        }}
      >
        {/* Country selector */}
        <button
          type="button"
          className={'pi-country' + (open ? ' open' : '')}
          onClick={() => setOpen(o => !o)}
        >
          <span className="pi-flag">{selected.flag}</span>
          <span className="pi-code">{selected.code}</span>
          <span className="pi-chevron">▾</span>
        </button>

        <div className="pi-divider" />

        {/* Number input */}
        <input
          type="tel"
          className="pi-number"
          placeholder="xx xxx xxxx"
          value={number}
          onChange={handleNumberChange}
          required={required}
        />
      </div>

      {/* Dropdown */}
      {open && (
        <ul className="pi-dropdown">
          {COUNTRIES.map(c => (
            <li
              key={c.code}
              className={'pi-option' + (selected.code === c.code ? ' selected' : '')}
              onMouseDown={() => handleCountrySelect(c)}
            >
              <span className="pi-flag">{c.flag}</span>
              <span className="pi-label">{c.label}</span>
              <span className="pi-code">{c.code}</span>
            </li>
          ))}
        </ul>
      )}

      {/* Validation feedback */}
      {showFeedback && (
        <span style={{
          fontSize: '12px',
          marginTop: '4px',
          display: 'block',
          color: isValid ? '#4caf7d' : 'var(--red)'
        }}>
          {isValid ? '✓ Valid phone number' : 'Please enter 7–12 digits'}
        </span>
      )}
    </div>
  );
}